// extracted by mini-css-extract-plugin
export default {"ButtonContainer":"ContextMenuButton_ButtonContainer__fq70s","Button":"ContextMenuButton_Button__chHsH","ButtonIcon":"ContextMenuButton_ButtonIcon__Mif6X"};